import { render, staticRenderFns } from "./ChangePasswordForm.vue?vue&type=template&id=564e0584&"
import script from "./ChangePasswordForm.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports